import { makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  kpiGroup: {
    width: `calc(100% - 32px - ${theme.hvSpacing(2)})`,
    overflowX: "auto",
    [theme.breakpoints.up("md")]: {
      width: `calc(100% - 32px - ${theme.hvSpacing(4)})`,
    },
    "& > div": {
      minWidth: 680,
    },
  },
  viewSwitchMultiButton: {
    width: `calc(32px + ${theme.hvSpacing(2)})`,
    [theme.breakpoints.up("md")]: {
      width: `calc(32px + ${theme.hvSpacing(4)})`,
    },
  },
  kpi: {
    minWidth: 170,
    "&$selectable": {
      cursor: "pointer",
    },
  },
  selectable: {},
  kpiEmptyState: {
    justifyContent: "start",
    marginLeft: 10,
  },
  kpiTitle: {
    margin: "0 20px",
    paddingTop: 10,
    ...theme.hv.typography.xsTitle,
  },
  kpiContent: {
    padding: "0 20px 10px",
  },
}));

export default styles;
